var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAcc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.243,
    height: 9.621,
    viewBox: "0 0 16.243 9.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-chevron-down",
    "data-name": "Icon feather-chevron-down",
    d: "M9,13.5l6,6,6-6",
    transform: "translate(-6.879 -11.379)",
    fill: "none",
    stroke: "#4d6382",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAcc);
export default __webpack_public_path__ + "static/media/arrow-acc.03cf3a33ac109a280557e116b5b0af34.svg";
export { ForwardRef as ReactComponent };